import "@fortawesome/fontawesome-free/css/all.css";

export default function() {}